module.exports = "<svg id=\"1953eb72-a648-4adc-9f6e-6af3ba475449\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>difference-rewards-program</title><polygon points=\"25 40.47 9.7 48.5 12.67 31.52 0.28 19.47 17.38 16.97 25 1.5 32.62 16.97 49.72 19.47 37.33 31.52 40.3 48.5 25 40.47\" style=\"fill:#fff\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/difference-rewards-program.svg
// module id = 535
// module chunks = 1